import React, { useState, useEffect } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, CircularProgress, Modal, Button, Divider, FormControl } from '@mui/material';
import Container from 'react-bootstrap/Container';
import { useNavigate } from 'react-router-dom';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';
import { TextField, MenuItem, Select } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { useSnackbar } from '../../SnackbarContext';
import GlobalVariable from "../../../services/Global";

const baseApiUrl = GlobalVariable.BASE_API_URL;

const style = {
  position: 'absolute',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  borderRadius: 4,
  justifyContent: "center",
  alignItems: "center",
  direction: "column",
  width: "90%",
  margin: 10
};

const headers = [
  'RFP Issuer', 'Added by', 'First Review', 'Conference Due', 'Questionnaire Date', 'Submission Date', 'POC Mail', 'RFP Type', 'NoGo Reason', 'Budget Range($)', 'Internal POC Name', 'Additional Status', 'Comments'
];

function OnHoldData({ searchTerm, activeDataa, loading }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [commentsModalOpen, setCommentsModalOpen] = useState(false);
  const [selectedRowComments, setSelectedRowComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [selectedRfpId, setSelectedRfpId] = useState('');
  const [fetchLoading, setFetchLoading] = useState(false);

  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();



  const filteredData = activeDataa.filter((row) => {
    const matchesSearchTerm = searchTerm.length > 3 ? row.rfp_issuer.toLowerCase().includes(searchTerm.toLowerCase()) : true;
    return matchesSearchTerm;
  });

  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);

  const paginatedData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const handleChangePage = (event, value) => {
    setCurrentPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const handleKeyPressPage = (event) => {
    if (event.key === 'Enter') {
      const pageNumber = parseInt(event.target.value.replace(/\D/, ''), 10);
      if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
        setCurrentPage(pageNumber);
      }
    }
  };

  const handleRowClick = (row) => {
    navigate(`/rfp-preview/${row.rfpid}`);
  };

  const fetchRfpComments = (rfpId) => {
    setFetchLoading(true);
    axios.get(`${baseApiUrl}/dashboard/fetchrfp?id=${rfpId}`)
      .then(response => {
        setSelectedRowComments(response.data.details.comments || []);
        setFetchLoading(false);
      })
      .catch(error => {
        console.error('Error fetching RFP comments:', error);
        setFetchLoading(false);
      });
  };

  const handleCommentsClick = (row) => {
    console.log('Row data:', row);
    console.log('Row comments:', row.comments);
    setSelectedRfpId(row.rfpid);
    setCommentsModalOpen(true);
    fetchRfpComments(row.rfpid);
  };

  const handleCloseCommentsModal = () => {
    setCommentsModalOpen(false);
    setSelectedRowComments([]);
    setNewComment('');
    setSelectedRfpId('');
  };

  const handleSaveComment = () => {
    if (newComment.trim()) {
      const storedData = JSON.parse(localStorage.getItem('userDetails'));
      const userId = storedData.userDetails.id;
      const commentData = {
        userid: userId,
        comments: newComment,
        rfpid: selectedRfpId,
        status: ''
      };

      axios.post(`${baseApiUrl}/dashboard/addrfpcomment`, commentData)
        .then(response => {
          fetchRfpComments(selectedRfpId);
          setNewComment('');
          showSnackbar('Comment added successfully.', 'success');
        })
        .catch(error => {
          console.error('Error saving comment:', error.response?.data || error.message);
          showSnackbar('Error saving comment. Please try again.', 'error');
        });
    }
  };
  return (
    <div>
      <Container fluid>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="400px">
            <CircularProgress className=' text-primary' />
          </Box>
        ) : (
          <>
            <TableContainer
              component={Paper}
              className='mt-3'
              sx={{
                width: '100%',
                height: '288px',
                overflow: 'auto',
                position: 'relative',
                '&::-webkit-scrollbar': {
                  height: '3px',
                  width: '3px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: '#888',
                  borderRadius: '6px',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  backgroundColor: '#555',
                  cursor: 'pointer',
                },
              }}
            >
              <Table aria-label="simple table" stickyHeader sx={{ minWidth: 1500 }}>
                <TableHead>

                  <TableRow sx={{
                    position: 'sticky',
                    top: 0,
                    backgroundColor: '#fff',
                    zIndex: 10,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}>
                    {headers.map((header, index) => (
                      <TableCell
                        key={header}
                        align="left"
                        className="fontstyleeb"
                        sx={{
                          width: index === 0 ? { xs: '120px', sm: 'auto' } : 'auto', // Reduced width for 320px screens
                          whiteSpace: index === 0 ? { xs: 'pre-wrap', sm: 'nowrap' } : 'nowrap', // Use pre-wrap for RFP Issuer on mobile
                          wordBreak: index === 0 ? 'normal' : 'normal', // Normal word breaking
                          minWidth: index === 0 ? { xs: '120px', sm: 'auto' } : 'auto', // Ensure minimum width
                          fontWeight: 'bold',
                          // Make first column (RFP Issuer) sticky
                          ...(index === 0 && {
                            position: 'sticky',
                            left: 0,
                            backgroundColor: '#fff',
                            zIndex: 11,
                            // borderRight: '2px solid #e0e0e0',
                            // boxShadow: '2px 0 4px rgba(0,0,0,0.1)'
                          })
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody className="position-relative">
                  {paginatedData.length > 0 ? (
                    paginatedData.map((row) => (
                      <TableRow
                        key={row.rfpid}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell
                          align="left"
                          sx={{
                            width: { xs: '120px', sm: 'auto' }, // Reduced width for 320px screens
                            whiteSpace: { xs: 'pre-wrap', sm: 'nowrap' }, // Use pre-wrap for better text flow
                            wordBreak: 'normal', // Normal word breaking
                            lineHeight: { xs: 1.4, sm: 'normal' }, // Better line spacing
                            maxWidth: { xs: '120px', sm: 'none' }, // Match width
                            minWidth: { xs: '120px', sm: 'auto' }, // Ensure minimum width
                            position: 'sticky',
                            left: 0,
                            backgroundColor: '#fff',
                            zIndex: 1,
                            // borderRight: '2px solid #e0e0e0',
                          }}
                          className=' fontstyleeb text-primary cursor'
                          onClick={() => handleRowClick(row)}
                        >{row.rfp_issuer || "NA"}</TableCell>
                        <TableCell align="left" sx={{ width: "auto", whiteSpace: "nowrap" }}>{row.created_by || "NA"}</TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>{row.first_review || "NA"}</TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>{row.conference_date || "NA"}</TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>{row.questionnaire_date || "NA"}</TableCell>
                        <TableCell align="left" sx={{ width: 'auto', whiteSpace: 'nowrap' }}> {row.submission_date || "NA"} </TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>{row.contact_email || "NA"}</TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>{row.rfp_type || "NA"}</TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>{row.comment || "NA"}</TableCell>
                        <TableCell align="right" sx={{ width: "auto", whiteSpace: "nowrap" }}>{row.budget_range || "NA"}</TableCell>
                        <TableCell align="left" sx={{ width: 'auto', whiteSpace: 'nowrap' }}>{row.internal_poc_name || "NA"}</TableCell>
                        <TableCell align="left" sx={{ width: 'auto', whiteSpace: 'nowrap' }}>{row.additional_status || "NA"}</TableCell>
                        <TableCell align="left" className='fontstyleeb text-primary cursor' sx={{ width: 'auto', whiteSpace: 'nowrap' }} onClick={() => handleCommentsClick(row)}>
                          Comments
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 100,
                        left: 450,
                      }}
                    >
                      <Typography variant="h6">No Records Found</Typography>
                    </Box>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {totalRows > 10 && paginatedData.length > 0 && (
              <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                <Box display="flex" alignItems="center">
                  <Typography variant="body2" className="mx-1 text-secondary">
                    Rows per page:
                  </Typography>
                  <Select
                    value={rowsPerPage}
                    onChange={handleChangeRowsPerPage}
                    size="small"
                    sx={{ marginRight: 2 }}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                  </Select>
                </Box>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handleChangePage}
                  sx={{
                    '& .Mui-selected': {
                      color: '#1976d2',
                    },
                  }}
                />
                <Box display="flex" alignItems="center">
                  <Typography variant="body2" className="mx-1 text-secondary">
                    Go to page:
                  </Typography>
                  <TextField
                    type="number"
                    value={currentPage}
                    onChange={(event) => setCurrentPage(parseInt(event.target.value, 10))}
                    onKeyPress={handleKeyPressPage}
                    variant="standard"
                    InputProps={{
                      disableUnderline: true,
                      sx: {
                        width: '60px',
                        textAlign: 'center',
                      },
                    }}
                    size="small"
                  />
                </Box>
              </Box>
            )}
          </>
        )}
      </Container>

      {/* Comments Modal */}
      <Modal
        open={commentsModalOpen}
        onClose={handleCloseCommentsModal}
        aria-labelledby="comments-modal-title"
        aria-describedby="comments-modal-description"
      >
        <FormControl fullWidth margin="normal" className="inputfields">
          <Box className="commentsboxeditrfp" sx={style}>
            <Box display="flex" justifyContent="space-between" alignItems="baseline">
              <Typography gutterBottom className='commentsText inputfields'>
                Comments
              </Typography>
              <CloseIcon onClick={handleCloseCommentsModal} style={{ cursor: 'pointer' }} />
            </Box>
            <Divider style={{ borderColor: '#adadad' }} />
            <Typography id="comments-modal-description" sx={{ mt: 2 }} className='addCommentText'>
              Add Comments
            </Typography>
            <TextField
              fullWidth
              label="Comment"
              variant="outlined"
              className='mb-2 rounded-5 mt-3'
              multiline
              rows={2}
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '16px',
                },
              }}
            />
            <Button
              variant="contained"
              className="mb-3 float-end bg-primary rounded-5"
              onClick={handleSaveComment}
            >
              Save
            </Button>
            <Typography className='mt-4 fs-6'>Previous Comment list</Typography>
            {fetchLoading ? (
              <Box display="flex" justifyContent="center" height="200px" alignItems="center">
                <CircularProgress className='text-primary' />
              </Box>
            ) : (
              <TableContainer
                component={Paper}
                sx={{
                  maxHeight: '300px',
                  overflowY: 'auto',
                  borderColor: 'ActiveBorder',
                  borderRadius: '12px',
                  marginTop: '15px'
                }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" className='remarkstext'>Comment</TableCell>
                      <TableCell align="left" className='remarkstext'>Commented Date</TableCell>
                      <TableCell align="left" className='remarkstext'>Comment By</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedRowComments.length > 0 ? (
                      selectedRowComments.map((comment, index) => (
                        <TableRow key={index}>
                          <TableCell align="left">{comment.comments}</TableCell>
                          <TableCell align="left">{comment.comment_date}</TableCell>
                          <TableCell align="left">{comment.comment_by}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center">No comments found</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>
        </FormControl>
      </Modal>
    </div>
  );
}

export default OnHoldData;